// PIXI app config
var pixiConfig = {
  backgroundColor: 0x000000,
  resizeTo: document.getElementById('canvas'),
  width: 640,
  height: 500
}

export default pixiConfig
